const lan = {
  REDIRECT: "Redirigiendo...",
  RULE: {
    SERVICE_TYPE: "Por favor, seleccione el tipo de servicio",
    COUNTRY: "Seleccione su país",
    USERNAME: "Se requiere un nombre de usuario",
    EMAIL: "Se requiere un correo electrónico",
    EMAIL2: "Por favor ingrese una dirección de correo valida.",
    PRODUCT: "Seleccione su dispositivo",
    PRODUCTSN: "Ingrese el número de serie de su producto",
    PRODUCTSN_LEN: "Por favor ingrese de 12 a 15 caracteres (numeros y letras)",
    BIRTHDAY: "Se requiere la fecha de nacimiento",
    REQUIRED: "Necesario",
  },
  SYS: {
    HEAD: "Sistema",
    NOSERVICE:
      "Lo sentimos, el Chat de Asus para la región que indicó no esta disponible.",
    CHECK_FILESIZE:
      "Por favor revise el tamaño del archivo adjunto. el limite es de: ",
    RECONNECTED: "El estado de la conexión ha vuelto a la normalidad",
    UNABLE_SEND: "No es posible enviar el archivo adjunto",
    NO_NETWORK: "Sin conexión a internet",
    NO_NETWORK_INFO:
      "Sin conexión a Internet. Por favor conecte su equipo a internet e intente de nuevo.",
  },
  IDLE: {
    HEAD: "Ha estado inactivo por un tiempo. ¿Desea continuar en el chat?",
    BUTTON: "Continuar",
  },
  DISCONNECT: {
    HEAD: "El chat ha finalizado",
    BUTTON: "Finalizar",
  },
  LAYOUT: {
    STEP_1: "Seleccione un producto",
    STEP_2: "Condiciones de uso",
    STEP_3: "Inicio de sesión",
    STEP_4: "Información",
    SELECT_SKILL: "Seleccione un producto",
    PREV_STEP: "Anterior",
    NEXT_STEP: "Siguiente",
    NOTSET: "No establecido.",
    AGREEN: "Acepto",
    NOTAGREEN: "No estoy de acuerdo",
    LEAVE: "Cerrar la sesión",
    TYPE_HERE: "Escriba aquí",
    CHAT_DOWNLOAD:
      "Por favor de click aquí para guardar una copia de su sesión de chat con el servicio en linea de ASUS.",
  },
  COUNTRY: { SELECT_COUNTRY: "Seleccione su país" },
  POLICY: {
    PRIVACY: "Política de protección de privacidad",
    SAT_SURVEY: "Acuerdo de servicio",
    CONFIRM_COUNTRY: {
      H1: "Estimado cliente,",
      P1:
        "Usted esta visitando el servicio a cliente en línea de ASUS para México, Centro y Sudamérica, el cual es diferente a su región. De acuerdo a los términos de garantía de ASUS, las garantía solo son válidas en el país de origen de su producto. puede continuar usando el servicio al cliente en línea de ASUS para México, Centro y Sudamérica o cambiar al servicio del país de origen de su producto.",
      P2: "",
      P3: "",
      B1: "Cambiar a ASUS",
      B2: "Sitio Web",
      B3: "Continuar usando",
    },
    BULLETIN: {
      HEAD: "Aviso de un mensaje importante",
      CONFIRM: "Entendido",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Por favor llene su información de contacto",
    SURVEY_TYPE: "Seleccione el tipo de servicio",
    PROBLEM_BRIEF: "¿Cómo describiria su problema?",
    TYPE1: "Pregunta general",
    TYPE2: "Solicitud de reparación",
    TYPE3: "Soporte técnico",
    TYPE4: "Consulta de garantía",
    TYPE5: "Comentarios y sugerencias",
    EC_TYPE1: "Información sobre productos y ventas",
    EC_TYPE2: "Evento de Marketing",
    EC_TYPE3: "Estado de envío y pedido",
    EC_TYPE4: "Servicio de devolución",
    SIGNUPDATA: "Su información de registro",
    NAME: "Nombre",
    TEL: "Número de teléfono",
    ORDER_NO: "Order No.",
    BIRTHDAY: "Fecha de nacimiento",
    LABEL_EMAIL: "Correo electrónico",
    EMAIL: "Correo electrónico",
    DEVICEINFO: "Información de su producto",
    DEVICENAME: "Nombre del producto",
    MY_DEVICE: "Su producto",
    MY_DEVICE_SELECT: "Seleccione su producto",
    MY_DEVICE_EMPTY: "Aun no tienes dispositivos.",
    LABEL_DEVICESN: "Número serie",
    DEVICESN: "Número de serie del producto",
    DEVICESN_ERROR: "La serie ingresada es inválida.",
    PREPARE: "Creando la sala de chat, preparándose para chatear",
    START: "Iniciar chat",
    AGE_LIMIT: "Límite de edad",
    AGE_LIMIT_DESC:
      "Usted no cumple con la edad minima para usar el servicio de Chat de ASUS",
    REPEAT_ENTRY: {
      H1: "Se detectó que usted ya tiene otra sesión de Chat",
      P1:
        "¿Seguro que desea iniciar una nueva conversación? la sesión anterior se cerrará.",
      B0: "Confirmar",
      B1: "Cancelar",
    },
  },
  CONNECTTING: {
    P1: "Por favor espere un momento, no cierre la ventana del Chat",
    P2: "El chat de ASUS le esta conectando con agente disponible",
    NOTE: "Sugerencia",
    BEFORE_LEAVE: "¿Esta seguro de querer terminar el Chat de ASUS?",
    B0: "Finalizar",
    B1: "Permanecer y esperar",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Contactar a ASUS por otros medios",
    MAIL: "Envíenos un correo electrónico",
    TEL: "Llámenos",
    CLOSE: "Cerrar",
  },
  WAITTING: {
    WATTING_NUM: "Posición en la fila",
    PEOPLE: "Cliente",
    NOTE: "Sugerencia",
    BEFORE_LEAVEL: "¿Esta seguro de querer abandonar la fila de espera?",
    LEAVE_DESC: "Sí desea abandonar la fila, puede terminar el Chat",
    LEAVE: "Finalizar el chat",
    STAY: "Permanecer en la fila",
  },
  CHATROOM: {
    TYPING: "El agente esta escribiendo...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Terminar el chat",
      TERMINATE: "Finalizar el chat",
    },
    FOOTER: { CHAT_FINISH: "El chat ha finalizado" },
    FINISH:
      "El chat ha terminado. ¿Necesita algún servicio o soporte adicional?",
    SAT_SURVEY: {
      SAT: "Satisfecho",
      DISSAT: "Insatisfecho",
      SAT_CHOOSE: "¿Qué tipo de servicios? (varios)",
      HEAD: "¿Está satisfecho con el chat?",
      DESC:
        "Con sus comentarios podremos mejorar continuamente. Por favor indiquenos si tiene sugerencias para mejorar el servicio o Soporte de ASUS.",
      OTHER_OPTION: "Otros",
      OTHER_REASON: "Por favor, indique otra razón",
      SEND: "Enviar",
    },
    CLOSE: {
      TITLE: "¿Está seguro que desea abandonar este chat?",
      P1:
        'Dé clic en "Terminar" para cerrar la ventana. Sí desea usar el chat nuevamente, por favor de clic en "Iniciar nuevo chat".',
      B0: "Finalizar",
      B1: "Cancelar",
    },
  },
  ERROR: {
    H1: "La sala de chat no existe o el chat ya ha finalizado",
    CLOSE: "Cerrar la ventana",
  },
  CHAT_END: {
    H1: "Muchas gracias, el chat ha finalizado",
    CLOSE: "Cerrar la ventana",
  },
  CHAT_CLOSE: {
    H1:
      "Su red ha estado desactivada durante más de 300 segundos, por lo que esta conversación ha finalizado.",
    DESC:
      "Si esta usando una red inalámbrica o movil, por favor muevase a una ubicación con mejor señal, o cambie a una red con cable. Lamentamos lso inconvenientes con su red.",
    CLOSE: "Cerrar la ventana",
  },
  SURVEY_DONE: {
    H1: "¡GRACIAS!. Ha terminado la encuesta de satisfacción de servicio",
    P1:
      'Sus comentarios nos ayudan a mejorar continuamente. Gracias por tomarse el tiempo para completar la encuesta de satisfacción de servicio. Sí requiere soporte adicional, por favor dé clic en "Iniciar nuevo chat". Por favor dé clic en "Cerrar la ventana" para terminar el chat.',
    AGAIN: "Iniciar un nuevo chat",
    CLOSE: "Cerrar la ventana",
    YT_H1:
      "Descubra sugerencias y conocimientos técnicos con los vídeos de asistencia de ASUS.",
    YT_H2: "¡Haz clic para conocer más!",
  },
  AGENT_OFFLINE: {
    H1:
      "La conexión a Internet del agente no esta respondiendo, el Chat se ha interrumpido.",
    H2:
      "Por favor no cierre la ventana, estamos trabajando para poder continuar el chat",
    DESC:
      'Tambien puede terminar el chat e iniciar la encuesta o dar clic en "Iniciar nuevo chat", e inmediatamente le asignaremos un nuevo agente para continuar el chat. Lamentamos los inconvenientes.',
    AGAIN: "Iniciar un nuevo chat",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "No se puede utilizar la cámara ni el micrófono",
    H1: "¿Listo para unirte?",
    P1:
      "Para que el personal del servicio de atención al cliente de ASUS pueda ayudarle a resolver el problema de forma más eficaz, debe permitir que el dispositivo acceda a su cámara y micrófono para unirse a la sala de chat de vídeo, y asegúrese de que su conexión de red móvil es estable y funciona con normalidad.",
    P2:
      "Después de acceder, puedes seguir ajustando libremente el botón del objetivo y el silencio del micrófono.",
    VIDEO_STATE: "Estado del vídeo",
    VIDEO_ON: "Encendido",
    VIDEO_OFF: "Apagado",
    AUDIO_STATE: "Estado de audio",
    AUDIO_ON: "Encendido",
    AUDIO_OFF: "Apagado",
    ENTER: "Unirse",
    HANGUP: {
      H1: "Terminar",
      P1: "¿Estás seguro de terminar la videollamada",
      CONFIRM: "Confirmar",
      CANCEL: "Cancelar",
    },
    END: {
      H1: "La videollamada ha finalizado",
      P1: "Gracias, esta videollamada ha terminado, puede cerrar esta ventana.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Seleccione un producto",
      STEP_2: "Condiciones del servicio",
      STEP_3: "Inicio de sesión",
      STEP_4: "Información",
      SELECT_SKILL: "Seleccione un producto",
      WELCOME: "Bienvenido",
      AGREE: "De acuerdo",
      START: "Iniciar",
      CANCEL: "Cancelar",
      WAIT: "Espere...",
      INPUT: "Ingrese texto",
      TRANSFER_TOAGENT: "Transferir a un agente.",
      READMORE:
        "También puede consultar las siguientes preguntas frecuentes relacionadas, gracias.",
      COLLAPSE: "Ocultar",
      INPUT_SN: "Por favor, vuelva a ingresar el número de serie",
      YOU_MAY_ALSO: "Tal vez tambien quieras preguntar:",
      FOR_FURTHER: "Para más información, por favor consulte:",
      RECORDING: "Comienza a dictarme...",
      RECORDING_NOT_SUPPORTED:
        "Su navegador no soporta el reconocimiento de voz",
      RECORDING_NOT_FOUND:
        "No se ha detectado un dispositivo de grabación. Compruebe el micrófono y los permisos.",
    },
    IS_COMPONENT_SN:
      "The input is the component serial number, you should enter the correct machine serial number.",
    WARRANTY: {
      SERIES: "Tipo de producto",
      MODEL: "Nombre del producto",
      SERIALNO: "Número de serie del producto",
      STATUS: "Estado de la garantía",
      DATE: "Fecha de expiración de la garantía",
    },
    HEAD: {
      LEAVE: "Abandonar",
      CREATE_NEW: "Crear nuevo",
    },
    ENTRANCE: {
      POLICY: "Política de privacidad",
      AGREE: "Clic en De acuerdo para iniciar la conversación",
    },
    MESSAGE: {
      WAIT: "Espere, estamos buscando una solución para usted.",
    },
    END: "La conversación ha terminado",
    END_MSG: "Estamos felices en ayudarle. La conversación ha terminado.",
    END_SURVEY: "Encuesta de satisfacción",
    END_SURVEY_MSG:
      "Estamos felices en ayudarle. La conversación ha terminado.",
    BACKHOME: "Regresar al inicio",
    SURVEY: {
      DESC: "Por favor califique su experiencia con el Asistente Virtual ASUS.",
      SAT: "Satisfecho",
      DISSAT: "Insatisfecho",
      FEEDBACK: "Por favor ingrese aquí sus comentarios",
      SEND: "Enviar",
      BACK: "Cancelar",
    },
    SURVEY_DISLIKE: {
      H1: "¿Por qué no estás satisfecha con la respuesta?",
      P: "Sus comentarios nos ayudan a mejorar la calidad de nuestro servicio.",
      BUTTON: "Enviar",
    },
    HISTORY: {
      TITLE: "Historial",
      AGO: "Hace {hours} horas",
      CONTINUE: "Continuar el chat",
      CLOSE: "La conversación ha finalizado.",
      RESTART: "Reanudar con Asistente Virtual",
      NON_SERVICE: "Horario fuera de servicio",
      VIEW_HISTORY: "Haz clic para ver el historial de chat más reciente.",
    },
  },
};
export default lan;
